import type { StorageTier } from '@respaldos/shared';

const TIER_LABELS: Record<StorageTier, { label: string; cls: string; map: string }> = {
  hot: { label: 'Caliente', cls: 'tier-hot', map: 'Standard' },
  auto: { label: 'Auto', cls: 'tier-auto', map: 'Intelligent-Tiering' },
  archive: { label: 'Archivo', cls: 'tier-archive', map: 'Glacier Instant' },
  deep: { label: 'Archivo profundo', cls: 'tier-deep', map: 'Deep Archive' },
};

export function TierBadge({ tier }: { tier: StorageTier | null }) {
  if (!tier) return <span className="muted">—</span>;
  const t = TIER_LABELS[tier];
  return (
    <span className={`tier ${t.cls}`} title={t.map}>
      {t.label}
    </span>
  );
}
